import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Field } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';

import AutosuggestField from 'components/fields/AutosuggestField';

import {
  requestFetchWorkflowStatuses,
  requestSearchWorkflowStatuses,
} from 'redux/modules/workflowStatuses';
import { accountLoginFail } from 'redux/modules/account';

const styles = () => ({
  root: {
    display: 'flex',
  },
  inputRoot: {
    display: 'flex',
  },
});

const StatsLineChartFormStatusFields = ({
  actions,
  classes,
  ...fields
}) => (
  <Field
    className={classes.root}
    inputRootClassName={classes.inputRoot}
    id="Status"
    name="Status"
    component={AutosuggestField}
    placeholder="-Status-"
    fullWidth
    listWidth="auto"
    size="sm"
    color="light"
    renderSuggestionContent={suggestion => suggestion.Name}
    onSuggestionSelected={(suggestion) => {
      fields['Workflow Status ID'].input.onChange(suggestion.ID);
      fields['Selected Status'].input.onChange(suggestion.Name);
      return suggestion.Name;
    }}
    fetchSuggestions={({ value, limit, offset }) => (
      value.length > 0 || fields['Workflow State ID'].input.value
        ? requestSearchWorkflowStatuses({
          filters: [
            ...value.length > 0 ? [{
              name: 'Name',
              operation: 'contains',
              val: value,
              case_sensitivity: false,
            }] : [],
            ...fields['Workflow State ID'].input.value ? [{
              name: 'Workflow State ID',
              operation: 'in',
              val: [fields['Workflow State ID'].input.value],
            }] : [],
          ],
          limit,
          offset,
        }).then(res => res.data,
          (err) => {
            if (err.data.error === 'Need authorisation') {
              actions.accountLoginFail();
            }
            return err;
          })
        : requestFetchWorkflowStatuses({
          limit,
          offset,
        }).then(res => res.data,
          (err) => {
            if (err.data.error === 'Need authorisation') {
              actions.accountLoginFail();
            }
            return err;
          })
    )}
    onlyConfirmedSelection
  />
);

StatsLineChartFormStatusFields.propTypes = {
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    inputRoot: PropTypes.string.isRequired,
  }).isRequired,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withStyles(styles)(StatsLineChartFormStatusFields),
);



// WEBPACK FOOTER //
// ./src/components/home/StatsLineChart/StatsLineChartFormStatusFields.js